import {
  SET_BUBBLE_VISIBILITY,
  SET_COLOR_SCHEME,
  SET_IS_MOBILE,
  SET_REFERRER_HOST,
  SET_PAGE_CONTEXT,
  SET_WIDGET_APP_CONFIG,
  SET_WIDGET_COLOR,
  SET_WIDGET_GRADIENT_COLOR,
  TOGGLE_WIDGET_OPEN,
} from '../types';

const state = {
  hideMessageBubble: false,
  isCampaignViewClicked: false,
  isMobile: false,
  isWebWidgetTriggered: false,
  isWidgetOpen: false,
  position: 'right',
  referrerHost: '',
  pageContext: null,
  showPopoutButton: false,
  widgetColor: '',
  widgetGradientColor: '',
  widgetStyle: 'standard',
  darkMode: 'light',
  orderTrackingEnabled: false,
};

export const getters = {
  getAppConfig: $state => $state,
  isRightAligned: $state => $state.position === 'right',
  getHideMessageBubble: $state => $state.hideMessageBubble,
  getIsWidgetOpen: $state => $state.isWidgetOpen,
  getWidgetColor: $state => $state.widgetColor,
  getWidgetGradientColor: $state => $state.widgetGradientColor,
  getReferrerHost: $state => $state.referrerHost,
  getPageContext: $state => $state.pageContext,
  isWidgetStyleFlat: $state => $state.widgetStyle === 'flat',
  darkMode: $state => $state.darkMode,
  getOrderTrackingEnabled: $state => $state.orderTrackingEnabled,
  getIsMobile: $state => $state.isMobile,
};

export const actions = {
  setAppConfig(
    { commit },
    {
      showPopoutButton,
      position,
      hideMessageBubble,
      widgetStyle = 'rounded',
      darkMode = 'light',
      orderTrackingEnabled = false,
    }
  ) {
    commit(SET_WIDGET_APP_CONFIG, {
      hideMessageBubble: !!hideMessageBubble,
      position: position || 'right',
      showPopoutButton: !!showPopoutButton,
      widgetStyle,
      darkMode,
      orderTrackingEnabled,
    });
  },
  toggleWidgetOpen({ commit }, isWidgetOpen) {
    commit(TOGGLE_WIDGET_OPEN, isWidgetOpen);
  },
  setWidgetColor({ commit }, widgetColor) {
    commit(SET_WIDGET_COLOR, widgetColor);
  },
  setWidgetGradientColor({ commit }, widgetGradientColor) {
    commit(SET_WIDGET_GRADIENT_COLOR, widgetGradientColor);
  },
  setColorScheme({ commit }, darkMode) {
    commit(SET_COLOR_SCHEME, darkMode);
  },
  setReferrerHost({ commit }, referrerHost) {
    commit(SET_REFERRER_HOST, referrerHost);
  },
  setPageContext({ commit }, pageContext) {
    commit(SET_PAGE_CONTEXT, pageContext);
  },
  setBubbleVisibility({ commit }, hideMessageBubble) {
    commit(SET_BUBBLE_VISIBILITY, hideMessageBubble);
  },
  setIsMobile({ commit }, isMobile) {
    commit(SET_IS_MOBILE, isMobile);
  },
};

export const mutations = {
  [SET_WIDGET_APP_CONFIG]($state, data) {
    $state.showPopoutButton = data.showPopoutButton;
    $state.position = data.position;
    $state.hideMessageBubble = data.hideMessageBubble;
    $state.widgetStyle = data.widgetStyle;
    $state.darkMode = data.darkMode;
    $state.locale = data.locale || $state.locale;
    $state.orderTrackingEnabled = data.orderTrackingEnabled ?? false;
  },
  [TOGGLE_WIDGET_OPEN]($state, isWidgetOpen) {
    $state.isWidgetOpen = isWidgetOpen;
  },
  [SET_WIDGET_COLOR]($state, widgetColor) {
    $state.widgetColor = widgetColor;
  },
  [SET_WIDGET_GRADIENT_COLOR]($state, widgetGradientColor) {
    $state.widgetGradientColor = widgetGradientColor;
  },
  [SET_REFERRER_HOST]($state, referrerHost) {
    $state.referrerHost = referrerHost;
  },
  [SET_PAGE_CONTEXT]($state, pageContext) {
    $state.pageContext = pageContext;
  },
  [SET_BUBBLE_VISIBILITY]($state, hideMessageBubble) {
    $state.hideMessageBubble = hideMessageBubble;
  },
  [SET_COLOR_SCHEME]($state, darkMode) {
    $state.darkMode = darkMode;
  },
  [SET_IS_MOBILE]($state, isMobile) {
    $state.isMobile = isMobile;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
